export const week = [
  '日',
  '月',
  '火',
  '水',
  '木',
  '金',
  '土',
];

export const crawlResultEnum = {
  '1': {
    label: 'OK',
    color: '#10B161',
  },
  '2': {
    label: 'NG',
    color: '#EA5B5B',
  },
  '3': {
    label: '-',
    color: '#181818',
  },
};

export const dynamicallyAddMapping = {
  'MOVIE': [
    'title', 'englishTitle', 'productionYear', 'openString', 'countries',
  ],
  'CAST': [
    'name', 'originalName', 'nameKana', 'sex', 'birthPlace', 'birth', 'mainRole',
  ],
};

export const getCountriesString = (value) => value ? value.join('／') : '';
export const getRolesString = (value) => {
  if (value && value.length > 0) {
    return value.map((item) => `[${item}]`).join('');
  }
  return '-';
};
